import { Component, OnInit, OnDestroy } from '@angular/core';
import { BasePageComponent } from '../base-page';
import { Store } from '@ngrx/store';
import { IAppState } from '../../interfaces/app-state';
import { HttpService } from '../../services/http/http.service';
import { Spinkit } from 'ng-http-loader';
import { IOption } from 'src/app/ui/interfaces/option';
import { Content } from '../../ui/interfaces/modal';
import { TCModalService } from '../../ui/services/modal/modal.service';
import Swal from 'sweetalert2'
import swal from 'sweetalert2'
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'app-dineinorders',
  templateUrl: './dineinorders.component.html',
  styleUrls: ['./dineinorders.component.scss'],
})

export class DineinordersComponent extends BasePageComponent implements OnInit, OnDestroy {
  restoID;
  public spinkit = Spinkit;
  data: IOption[];
  errorMessage
  resto = []
  food_dishes_name
  food_dishes_spice_rating
  selectStatus
  tag_id
  dietPrefOp
  allergeOp
  tagview
  last_update
  searchText
  restaurant_image
  getTableDetails = []
  getTableDetailsCompleted = []
  viewOrder: boolean = false
  viewOrderLive = []
  viewOrderCompleted = []
  constructor(
    store: Store<IAppState>,
    httpSv: HttpService,
    private modal: TCModalService,
    private router: Router,
    private httpClient: HttpClient
  ) {
    super(store, httpSv);
    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: 'Main'
        }
      ]
    };
  }
  ngOnInit() {
    this.restoID = localStorage.getItem('restoID');
    super.ngOnInit();
    this.restaurantDineInOrders();
    this.getData('assets/data/dininliveorderstatus.json', 'data');
    this.restaurantDineInOrderscompleted();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  tags = []
  getTag() {
    this.httpSv.getTag().subscribe(
      response => {
        if (response['status'] == true) {
          this.tags = response['result'].data;
        }
      },(err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  restaurantDineInOrders() {
    this.httpSv.restaurantDineInOrders().subscribe(
      response => {
        if (response['status'] == true) {
          this.getTableDetails = response['result'].data;
        }
      },(err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout(); 
        }         
      }
    )
  }


  restaurantDineInOrderscompleted() {
    this.httpSv.restaurantDineInOrderscompleted().subscribe(
      response => {
        if (response['status'] == true) {
          this.getTableDetailsCompleted = response['result'].data;
        }
      },(err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }            
      }
    )
  }

  TableID
  TableName
  TableStatus
  openModal<T>(body: Content<T>, value, name, tablestatus) {
    this.TableID = value
    this.TableName = name
    this.selectStatus = tablestatus
    this.modal.open({
      body: body,
    });
  }
  closeModal() {
    this.modal.close();
  }
  UpdateDineinLiveOrder(status) {
    this.httpSv.UpdateDineinLiveOrderStatus(status, this.TableID).subscribe(
      response => {
        if (response['status'] == true) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/horizontal/orders']);
        }); 
          this.closeModal();
        }
      },(err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }         
      }
    )
  }

  logout() {
    this.httpSv.logout().subscribe(
      response => {
        localStorage.clear();
        setTimeout(()=>{
          this.router.navigate(['/public/sign-in'])
        })
      },
      err => {
        console.log(err);
      }
    );
  }

  usersOrders
  allergensDetails
  allergensDetailsString
  orderDetails(id) {
    this.viewOrder = true
    this.httpSv.restaurantDineInOrdersViewDetails(id).subscribe(
      response => {
        if (response['status'] == true) {
          this.viewOrderLive = response['result'].data;
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  completedOrderDetails(id) {
    this.viewOrder = true
    this.httpSv.restaurantDineInOrdersCompletedViewDetails(id).subscribe(
      response => {
        if (response['status'] == true) {
          this.viewOrderLive = response['result'].data;
        }
      },(err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }      
      }
    )
  }
      allergen_value(obj){
      return Array.prototype.map.call(obj, s => s.allergens_name).toString(); 
      }
      dietary_value(obj){
      return Array.prototype.map.call(obj, s => s.diet_preference_name).toString(); 
      }
  Onscroll(event): void{
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
          window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
          window.clearInterval(scrollToTop);
      }
  }, 16);}

  backToLiveOrders() {
    this.viewOrder = false
  }
  counters(value) {
    let spiceValue =[]
    for(let i=0; i< value; i++){
      spiceValue.push(value)
    }
    return spiceValue;
  }
  counter(value) {
    let spiceValue =[]
    for(let i=0; i< value; i++){
      spiceValue.push(value)
    }
    return spiceValue;
  }
  checkAllergences(allergenceList) {
    if (typeof allergenceList.allergens == 'object' && Array.isArray(allergenceList.allergens) && Object.keys(allergenceList.allergens).length)
      return true;
    return false;
  }

  checkDietary(dietaryList) {
    if (typeof dietaryList.dietary == 'object' && Array.isArray(dietaryList.dietary) && Object.keys(dietaryList.dietary).length)
      return true;
    return false;
  }
  value_amount(val){
    return parseFloat(val).toFixed(2);  
  }
}

